import { MeasurementCalculationsItemType, MeasurementCalculations } from 'models/product-configuration.model';

const basicInfoGroup = {
  title: 'MODALS.MEASUREMENT_CALCULATIONS.BASIC_INFO.TITLE',
  items: [
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.BASIC_INFO.BASIC.ORDER_SIZE',
      value: [], // dropdown values
      controlName: 'size',
      type: MeasurementCalculationsItemType.INPUT // TODO: change to dropdown
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.BASIC_INFO.BASIC.WIDTH',
      value: 0,
      controlName: 'width',
      type: MeasurementCalculationsItemType.INPUT
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.BASIC_INFO.BASIC.HEIGHT',
      value: 0,
      controlName: 'height',
      type: MeasurementCalculationsItemType.INPUT
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.BASIC_INFO.BASIC.THICKNESS',
      value: 0,
      controlName: 'thickness',
      type: MeasurementCalculationsItemType.INPUT
    }
  ]
};

const glassInfoGroup = {
  title: 'MODALS.MEASUREMENT_CALCULATIONS.BASIC_INFO.TITLE',
  items: [
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.BASIC_INFO.GLASS.ORDER_SIZE',
      value: 'Wandöffnungsmaß', // dropdown value
      controlName: 'size',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.BASIC_INFO.GLASS.WIDTH',
      value: 0,
      controlName: 'width',
      type: MeasurementCalculationsItemType.INPUT
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.BASIC_INFO.GLASS.HEIGHT',
      value: 0,
      controlName: 'height',
      type: MeasurementCalculationsItemType.INPUT
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.BASIC_INFO.GLASS.THICKNESS',
      value: 0,
      controlName: 'thickness',
      type: MeasurementCalculationsItemType.INPUT
    }
  ]
};

const basicDoorLeafGroup = {
  title: 'MODALS.MEASUREMENT_CALCULATIONS.DOOR_LEAF.TITLE',
  items: [
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.DOOR_LEAF.BASIC.WIDTH',
      value: [860],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.DOOR_LEAF.BASIC.HEIGHT',
      value: [1985],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    }
  ]
};

const glassDoorLeafGroup = {
  title: 'MODALS.MEASUREMENT_CALCULATIONS.DOOR_LEAF.TITLE',
  items: [
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.DOOR_LEAF.GLASS.A_WIDTH',
      value: [0],
      controlName: 'aWidth',
      type: MeasurementCalculationsItemType.INPUT
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.DOOR_LEAF.GLASS.A1',
      value: [0],
      controlName: 'a1',
      type: MeasurementCalculationsItemType.INPUT
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.DOOR_LEAF.GLASS.A2',
      value: [0],
      controlName: 'a2',
      type: MeasurementCalculationsItemType.INPUT
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.DOOR_LEAF.GLASS.A3',
      value: [0],
      controlName: 'a3',
      type: MeasurementCalculationsItemType.INPUT
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.DOOR_LEAF.GLASS.A_HEIGHT',
      value: [0],
      controlName: 'aHeight',
      type: MeasurementCalculationsItemType.INPUT
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.DOOR_LEAF.GLASS.A4',
      value: [0],
      controlName: 'a4',
      type: MeasurementCalculationsItemType.INPUT
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.DOOR_LEAF.GLASS.A5',
      value: [0],
      controlName: 'a5',
      type: MeasurementCalculationsItemType.INPUT
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.DOOR_LEAF.GLASS.A6',
      value: [0],
      controlName: 'a6',
      type: MeasurementCalculationsItemType.INPUT
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.DOOR_LEAF.GLASS.DIMENSION',
      value: [535, 1420],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    }
  ]
};

const basicFrameGroup = {
  title: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.TITLE',
  items: [
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.BASIC.1',
      value: [2000, 2500],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.BASIC.2',
      value: [1980, 2487],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.BASIC.3',
      value: [820, 1970],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.BASIC.4',
      value: [1956, 2476],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.BASIC.5',
      value: [2076, 2536],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    }
  ]
};

const glassFrameGroup = {
  title: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.TITLE',
  items: [
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.GLASS.1',
      value: [0],
      controlName: 'glassAssembly',
      type: MeasurementCalculationsItemType.INPUT
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.GLASS.2',
      value: [1980, 2487],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.GLASS.3',
      value: [820, 1970],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.GLASS.4',
      value: [1956, 2476],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.GLASS.5',
      value: [841, 1981],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.GLASS.6',
      value: [2076, 2536],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.GLASS.7',
      value: [1956, 453],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.GLASS.7_2',
      value: [1956, 453],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.GLASS.8',
      value: [1073, 1892],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    },
    {
      label: 'MODALS.MEASUREMENT_CALCULATIONS.FRAME.GLASS.8_2',
      value: [1073, 1892],
      controlName: '',
      type: MeasurementCalculationsItemType.READONLY
    }
  ]
};

export const MEASUREMENT_CALCULATIONS: MeasurementCalculations[] = [
  {
    title: 'MODALS.MEASUREMENT_CALCULATIONS.TAB_1',
    img: 'measurement.svg',
    id: 'measurementRelations',
    groups: [
      [basicInfoGroup, basicDoorLeafGroup], [basicFrameGroup]
    ]
  },
  {
    title: 'MODALS.MEASUREMENT_CALCULATIONS.TAB_2',
    img: 'cut-a.svg',
    id: 'cutA',
    groups: [
      [glassInfoGroup, glassDoorLeafGroup], [glassFrameGroup]
    ]
  },
  {
    title: 'MODALS.MEASUREMENT_CALCULATIONS.TAB_3',
    img: 'cut-b.svg',
    id: 'cutB',
    groups: [
      [glassInfoGroup, glassDoorLeafGroup], [glassFrameGroup]
    ]
  }
];
